import React from "react";

export default function SearchBar({ searchTerm, setSearchTerm, filteredMenuLength }) {
  return (
    <div className="menu-search-row">
      <input
        aria-label="Search menu items"
        className="menu-search-input"
        placeholder="Search by name..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <div className="menu-results-info">{filteredMenuLength} item(s)</div>
    </div>
  );
}
